import { useEffect, useState } from "react";
import { Button, Modal } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import PubSub from "../../../../../services/PubSub";

const DisplayItemUsageInConditions = () => {
    const [translate] = useTranslation();
    const [show, setShow] = useState(false);
    const [title, setTitle] = useState('');
    const [initialLabel, setInitialLabel] = useState('');
    const [whereUsed, setWhereUsed] = useState(null);

    useEffect(() => {
        const showId = PubSub.subscribe("show_info_item_usage", ({ whereUsed, title, initialLabel }) => {
            setWhereUsed(whereUsed);
            setTitle(title);
            setInitialLabel(initialLabel);
            setShow(true);
        });

        return () => {
            PubSub.unsubscribe("show_info_item_usage", showId);
        }
    }, [translate]);

    return <Modal show={show} backdrop="static">
        <Modal.Header className="h5 text-secondary">{title}</Modal.Header>
        <Modal.Body>
            <label>{initialLabel}</label>
            <ul>
                {whereUsed && Object.keys(whereUsed).map((key) => {
                    if (!whereUsed[key].isUsed && whereUsed[key].items.length === 0) {
                        return null;
                    }

                    return <li key={key}>
                        <span>
                            {whereUsed[key].isUsed ?
                                `${key} - ${whereUsed[key].isUsed}` :
                                key
                            }
                        </span>

                        {whereUsed[key].items.length !== 0 && <ul>
                            {whereUsed[key].items.map((item) =>
                                <li key={`${key}.${item.name}`}>
                                    {item}
                                </li>
                            )}
                        </ul>}
                    </li>
                })}
            </ul>
        </Modal.Body>
        <Modal.Footer>
            <Button onClick={() => setShow(false)} variant="secondary" className="btn-sm">{translate("OTM_CLOSE")}</Button>
        </Modal.Footer>
    </Modal>
}

export default DisplayItemUsageInConditions;